import { Link, styled } from '@ghq-abi/design-system';

export const LinkTo = styled(Link, {
  color: '#006ADC',
  textDecoration: 'underline',
  fontWeight: '$normal',
  fontSize: '$sm',
});
